import React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function DevicesTable({ devices, onMapClick, onHistoryClick, onPingCountClick, onToggleStatus, onLocationClick, onDeviceClick, role, deviceStatusControlEnabled, onToggleUpdateStatus }) {
    const showVersionColumns = role === 'SUPPORT';

    const columnCount = 4
        + (showVersionColumns ? 2 : 0)
        + (deviceStatusControlEnabled ? 1 : 0)
        + (role !== 'FIELD_OFFICER' ? 1 : 0);

    const handleDeviceNavigate = (device, event) => {
        if (event?.target?.closest?.('[data-device-action]')) return;
        onDeviceClick?.(device);
    };

    const getRecords = () => {
        return devices.map((device, index) => (
            <tr
                key={device.device_id || index}
                className={device.device_id ? 'device-row-clickable' : undefined}
                onClick={(event) => device.device_id && handleDeviceNavigate(device, event)}
            >
                <td>{index + 1}</td>
                <td data-label="DEVICE ID" className="text-uppercase fw-bold">
                    {device.device_id ? (
                        <Link
                            to={`/device/${device.device_id}`}
                            state={{ device }}
                            className="text-uppercase fw-bold text-decoration-none"
                            onClick={(event) => event.stopPropagation()}
                        >
                            {device.device_id}
                        </Link>
                    ) : (
                        'N/A'
                    )}
                </td>
                <td data-label="PARTNER NAME" className="text-capitalize">
                    {device.partner_name || 'Unassigned'}
                </td>
                <td data-label="FIELD OFFICER NAME" className="text-capitalize">
                    {device.field_officer_name || 'Unassigned'}
                </td>
                {showVersionColumns && (
                    <td data-label="SOFTWARE VERSION">
                        <div className="small">
                            <div>Display: {device.display_software_version || '—'}</div>
                            <div>Firmware: {device.device_software_version || '—'}</div>
                        </div>
                    </td>
                )}
                {showVersionColumns && (
                    <td data-label="HARDWARE VERSION">
                        {device.hardware_version || '—'}
                    </td>
                )}
                {deviceStatusControlEnabled && (
                    <td data-label="STATUS">
                        <span className={device.device_status === false ? 'text-danger fw-bold' : 'text-success fw-bold'}>
                            {device.device_status === false ? '🔴 Disabled' : '🟢 Enabled'}
                        </span>
                    </td>
                )}
                {role !== 'FIELD_OFFICER' && (
                    <td data-label="ACTIONS" style={{ width: '260px' }}>
                        <div className="d-flex gap-2 justify-content-center flex-wrap" data-device-action>
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => onMapClick(device)}
                            >
                                Map
                            </Button>
                            {(role === 'PARTNER' || role === 'TEAM_MEMBER') && (
                                <Button
                                    variant="outline-warning"
                                    size="sm"
                                    onClick={() => onLocationClick(device)}
                                >
                                    Location
                                </Button>
                            )}
                            {role === 'SUPPORT' && (
                                <>
                                    <Button
                                        variant="outline-info"
                                        size="sm"
                                        onClick={() => onHistoryClick(device)}
                                    >
                                        History
                                    </Button>
                                    <Button
                                        variant="outline-success"
                                        size="sm"
                                        onClick={() => onPingCountClick(device)}
                                    >
                                        Ping Count
                                    </Button>
                                    <Button
                                        variant={device.auto_update_enabled ? 'secondary' : 'primary'}
                                        size="sm"
                                        onClick={() => onToggleUpdateStatus(device)}
                                    >
                                        {device.auto_update_enabled ? 'Disable Update' : 'Enable Update'}
                                    </Button>
                                    {deviceStatusControlEnabled && (
                                        <Button
                                            variant={device.device_status === false ? 'success' : 'danger'}
                                            size="sm"
                                            onClick={() => onToggleStatus(device)}
                                        >
                                            {device.device_status === false ? 'Enable' : 'Disable'}
                                        </Button>
                                    )}
                                </>
                            )}
                        </div>
                    </td>
                )}
            </tr>
        ));
    };

    return (
        <table
            className={`table table-striped text-center table-borderless ${devices.length > 1 ? 'align-middle' : ''
                }`}
            style={{ tableLayout: 'auto', width: '100%' }}
        >
            <thead className="table-dark align-top">
                <tr>
                    <th style={{ width: '60px' }}>S.NO.</th>
                    <th style={{ width: '150px' }}>DEVICE ID</th>
                    <th style={{ width: '200px' }}>PARTNER NAME</th>
                    <th style={{ width: '200px' }}>FIELD OFFICER NAME</th>
                    {showVersionColumns && (
                        <th style={{ width: '140px' }}>SOFTWARE VERSION</th>
                    )}
                    {showVersionColumns && (
                        <th style={{ width: '140px' }}>HARDWARE VERSION</th>
                    )}
                    {deviceStatusControlEnabled && (
                        <th style={{ width: '120px' }}>STATUS</th>
                    )}
                    {role !== 'FIELD_OFFICER' && (
                        <th style={{ width: '200px' }}>ACTIONS</th>
                    )}
                </tr>
            </thead>
            <tbody>
                {devices.length > 0 ? (
                    getRecords()
                ) : (
                    <tr>
                        <td className="no-entries" colSpan={columnCount}>
                            No Devices Found...
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}

export default DevicesTable;
